/**
 * Values of the `X-Sunny16-Error-Type` header Sunny16 sends on some storefront
 * 400s. New values may be added; existing ones are never repurposed, so an
 * unrecognised value is treated as an ordinary 400. Mirrors
 * `StorefrontErrorHeaders.cs` in sunny16-commerce.
 */
export enum StorefrontErrorType {
  /** Avalara could not resolve the address tax is calculated against. */
  AddressUnresolvable = 'AddressUnresolvable'
}

/** Response headers that describe a storefront error. Exposed to the browser via CORS. */
export enum StorefrontErrorHeader {
  ErrorType = 'X-Sunny16-Error-Type',
  /** Comma-separated `AddressStorefrontDto` property names. Omitted when the backend can't tell. */
  ErrorFields = 'X-Sunny16-Error-Fields'
}
